class SummaryContext {
  static serviceNumber: number;
  static doctorName: string;
}

export default SummaryContext;